import React, { useEffect, useState } from 'react';
import {
  Box,
  Heading,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Spinner,
  Badge,
  Select,
  useToast,
} from '@chakra-ui/react';
import axios from '../../../axiosConfig';

const statusOptions = ['received', 'contacted', 'archived'];
const statusColors = {
  received: 'gray',
  contacted: 'orange',
  archived: 'green',
};

const TourLeadsList = () => {
  const [tourLeads, setTourLeads] = useState([]);
  const [loading, setLoading] = useState(true);
  const toast = useToast();

  useEffect(() => {
    axios.get('/admin/tour_leads')
      .then(res => setTourLeads(res.data))
      .catch(err => console.error('Error fetching tour leads', err))
      .finally(() => setLoading(false));
  }, []);

  const handleStatusChange = async (id, newStatus) => {
    try {
      await axios.patch(`/admin/tour_leads/${id}`, { status: newStatus });
      setTourLeads((prev) =>
        prev.map((lead) =>
          lead.id === id ? { ...lead, status: newStatus } : lead
        )
      );
      toast({
        title: 'Status updated',
        status: 'success',
        duration: 3000,
        isClosable: true,
      });
    } catch (err) {
      console.error('Error updating status:', err);
      toast({
        title: 'Update failed',
        description: 'Could not update status. Please try again.',
        status: 'error',
        duration: 4000,
        isClosable: true,
      });
    }
  };

  return (
    <Box p={6}>
      <Heading as="h2" size="lg" mb={6}>Tour Leads</Heading>
      {loading ? (
        <Spinner />
      ) : (
        <Table variant="simple">
          <Thead>
            <Tr>
              <Th>Name</Th>
              <Th>Email</Th>
              <Th>Phone</Th>
              <Th>Status</Th>
              <Th>Submitted</Th>
            </Tr>
          </Thead>
          <Tbody>
            {tourLeads.map((lead) => (
              <Tr key={lead.id}>
                <Td>{lead.name}</Td>
                <Td>{lead.email}</Td>
                <Td>{lead.phone}</Td>
                <Td>
                  <Select
                    value={lead.status}
                    onChange={(e) => handleStatusChange(lead.id, e.target.value)}
                    size="sm"
                    bg={`${statusColors[lead.status]}.100`}
                    borderColor={`${statusColors[lead.status]}.300`}
                    maxW="150px"
                  >
                    {statusOptions.map((option) => (
                      <option key={option} value={option}>
                        {option.charAt(0).toUpperCase() + option.slice(1)}
                      </option>
                    ))}
                  </Select>
                </Td>
                <Td>{new Date(lead.created_at).toLocaleString()}</Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      )}
    </Box>
  );
};

export default TourLeadsList;